import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, Button, Notice } from '@origo/origo-ui';
import type { DocumentFormValues } from '../../../types';
import DocumentForm, { type DocumentFieldErrors } from './DocumentForm';

interface ReplaceDocumentDialogProps {
    open: boolean;
    dokumentnavn: string;
    values: DocumentFormValues;
    file: File | null;
    fieldErrors: DocumentFieldErrors;
    fileError?: string;
    onChange: (field: keyof DocumentFormValues, value: string) => void;
    onFileChange: (file: File | null) => void;
    onClose: () => void;
    onSave: () => void;
    isSaving?: boolean;
}

/** Erstatt plandokument (#14589): laster opp ny fil/record, sletter så det gamle. */
const ReplaceDocumentDialog: React.FC<ReplaceDocumentDialogProps> = ({
    open,
    dokumentnavn,
    values,
    file,
    fieldErrors,
    fileError,
    onChange,
    onFileChange,
    onClose,
    onSave,
    isSaving = false,
}) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            title={t('documents.replace.title')}
            footer={
                <>
                    <Button variant="secondary" onClick={onClose} disabled={isSaving}>
                        {t('common.cancel')}
                    </Button>
                    <Button variant="danger" onClick={onSave} disabled={isSaving}>
                        {t('documents.replace.submit')}
                    </Button>
                </>
            }
        >
            <Notice variant="warning">{t('documents.replace.warning', { navn: dokumentnavn })}</Notice>
            <DocumentForm
                values={values}
                file={file}
                fieldErrors={fieldErrors}
                fileError={fileError}
                onChange={onChange}
                onFileChange={onFileChange}
            />
        </Dialog>
    );
};

export default ReplaceDocumentDialog;
